import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ModifierGroupTypeService} from "app/services/modifier-group-type.service";
import {
  ModifierGroupAddingTypeEnum,
  ModifierGroupType,
  ModifierGroupTypeUpdateDto,
  ModifierGroupVisualTypeEnum
} from "app/models/menu.model";
import {BaseModalComponent} from "app/shared/base-modal/base-modal.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-modifier-group-type-modal',
  templateUrl: './modifier-group-type-modal.component.html',
  styleUrls: ['./modifier-group-type-modal.component.scss']
})
export class ModifierGroupTypeModalComponent extends BaseModalComponent {
  form: FormGroup;
  private initValues: {
    id: string;
    typeName: string;
    addingType: string;
    visualType: string
  };
  addingTypes = [
    'Addon',
    'Removals',
  ];
  visualTypes = [
    'Default',
    'Window',
    'Widget',
    'Popup',
    'Minimal',
  ];
  visualTypesForAddon = [
    'Default',
    'Widget',
  ];
  visualTypesForRemovals = [
    'Minimal',
  ];

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ModifierGroupTypeModalComponent>,
    private modifierGroupTypeService: ModifierGroupTypeService,
    @Inject(MAT_DIALOG_DATA) public data: ModifierGroupTypeModalData,
  ) {
    super(dialogRef);
    this.initValues = {...data.modifierGroupType}
    this.form = new FormGroup({});
    this.form.addControl('typeName', new FormControl(this.initValues.typeName));
    this.form.addControl('addingType', new FormControl(this.initValues.addingType));
    this.form.addControl('visualType', new FormControl(this.initValues.visualType));
  }

  async submit() {

    const visualType = this.form.value[ 'visualType' ];
    const addingType = this.form.value[ 'addingType' ];

    if(!this.validate(visualType, addingType)){
      alert("invalid visual type");
      return;
    }

    const result: ModifierGroupTypeUpdateDto = {
      typeName: this.form.value[ 'typeName' ],
      addingType: addingType,
      visualType: visualType,
    }

    if (this.data.modifierGroupType?.id) {
      const response = await this.modifierGroupTypeService.update(this.data.modifierGroupType.id, result);
      this.exit({updated: {id: this.data.modifierGroupType.id, ...response}});
    } else {
      const response = await this.modifierGroupTypeService.create(this.data.menuId, result);
      this.exit({created: response});
    }
  }

  validate(visualTypeValue: string, addingTypeValue: string){
    var values = this.filteredVisualTypes(addingTypeValue);
    if (values.includes(visualTypeValue)) {
      return true;
    }
    return false;
  }

  filteredVisualTypes(addingTypeValue: string) {
    if (addingTypeValue == this.addingTypes[0]) {
      return this.visualTypesForAddon
    } else if (addingTypeValue == this.addingTypes[1]) {
      return this.visualTypesForRemovals;
    } else {
      return [];
    }
  }

  async delete() {
    this.exit({deleted: this.data.modifierGroupType.id})
  }
}

export interface ModifierGroupTypeModalData {
  modifierGroupType: ModifierGroupType;
  menuId: string;
}
